import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-soma-border bg-soma-surface/40 mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-6">
            <Activity className="w-5 h-5 text-soma-primary" strokeWidth={2.5} />
            <span className="font-display font-bold text-2xl tracking-tight">neurofdback.ca</span>
          </div>
          <p className="font-serif-editorial italic text-2xl text-soma-muted leading-snug max-w-md">
            Training the mind is no longer a metaphor. It is a measurable practice.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <h4 className="text-xs uppercase tracking-[0.3em] text-soma-muted mb-6">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/programs" className="hover:text-soma-primary transition-colors">Programs</Link></li>
            <li><a href="/#manifesto" className="hover:text-soma-primary transition-colors">Manifesto</a></li>
            <li><a href="/#science" className="hover:text-soma-primary transition-colors">Science</a></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.3em] text-soma-muted mb-6">Account</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/login" className="hover:text-soma-primary transition-colors">Log in</Link></li>
            <li><Link to="/register" className="hover:text-soma-primary transition-colors">Create account</Link></li>
            <li><Link to="/dashboard" className="hover:text-soma-primary transition-colors">Dashboard</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-soma-border">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-soma-muted">
          <span>© 2026 neurofdback.ca. All rights reserved.</span>
          <span>Built for the focused.</span>
        </div>
      </div>
    </footer>
  );
}
